import { render, staticRenderFns } from "./RegionalReports.vue?vue&type=template&id=51034adb"
import script from "./RegionalReports.vue?vue&type=script&lang=js"
export * from "./RegionalReports.vue?vue&type=script&lang=js"
import style0 from "./RegionalReports.vue?vue&type=style&index=0&id=51034adb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports